import axios from "axios";
import i18n from "../../i18n";

const actions = {
  approveEnvironmentalReport(context, { id }) {
    return axios
      .post("environmentalReport/" + id + "/approve")
      .then((r) => {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("riskAssessment.proof.proofedMessage"),
        );
        return r.data;
      })
      .catch((e) => {
        context.dispatch("triggerError", e);
        throw e;
      });
  },

  rejectEnvironmentalReport(context, { id, reason }) {
    return axios
      .post("environmentalReport/" + id + "/reject", { reason })
      .then((r) => {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("riskAssessment.proof.rejectedMessage"),
        );
        return r.data;
      })
      .catch((e) => {
        context.dispatch("triggerError", e);
        throw e;
      });
  },

  getEnvironmentalReportVersions(context, id) {
    return axios
      .get("environmentalReport/" + id + "/versions")
      .then((r) => r.data)
      .catch((e) => {
        context.dispatch("triggerError", e);
        return { versions: [], currentVersion: 0, canProof: false };
      });
  },

  bulkDeleteEnvironmentalReports(context, ids) {
    return axios
      .post("environmentalReport/bulk-delete", { ids })
      .then((r) => {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("environmentalReports.bulk.deletedMessage"),
        );
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  getEnvironmentalReportYearCounts(context) {
    return axios
      .get("environmentalReport/yearCounts")
      .then((r) => r.data.counts || {})
      .catch((e) => context.dispatch("triggerError", e));
  },

  getEnvironmentalReportMonthCounts(context, year) {
    return axios
      .get("environmentalReport/monthCounts", { params: { year } })
      .then((r) => r.data.counts || {})
      .catch((e) => context.dispatch("triggerError", e));
  },

  createEnvironmentalReport(context, value) {
    return axios
      .post("environmentalReport", value)
      .then((r) => {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("environmentalReports.createdMessage", { name: r.data.name }),
        );
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  updateEnvironmentalReport(context, value) {
    return axios
      .put("environmentalReport/" + value.id, value)
      .then((r) => {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("environmentalReports.updatedMessage", { name: r.data.name }),
        );
        return r.data;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  deleteEnvironmentalReport(context, val) {
    return axios
      .delete("environmentalReport/" + val.id)
      .then((res) => {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("environmentalReports.deletedMessage"),
        );
        return res;
      })
      .catch((e) => context.dispatch("triggerError", e));
  },

  getSingleEnvironmentalReport(context, id) {
    return axios
      .get("environmentalReport/" + id, { params: { populate: "responsible" } })
      .then((r) => r.data)
      .catch((e) => context.dispatch("triggerError", e));
  },

  getEnvironmentalReportStats(context) {
    return axios
      .get("environmentalReport/stats")
      .then((r) => r.data)
      .catch((e) => context.dispatch("triggerError", e));
  },
};

export default actions;
